<template>
  <div class="col table-responsive">
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th scope="col" class="multi-line-header">22.4%-1 D</th>
          <th scope="col" class="multi-line-header">Produktionsdatum</th>
          <th scope="col" class="multi-line-header">Operator</th>
          <th scope="col" class="multi-line-header">Chargen Nr.</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(entry, tableId) in entriesType1" :key="tableId">
          <td></td>
          <td>{{ entry.dateinproduction.replace("T", " ") }}</td>
          <td>{{ entry.firstname }} {{ entry.lastname }}</td>
          <td>{{ entry.cellbatch }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="col table-responsive">
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th scope="col" class="multi-line-header">22.4%-2 D</th>
          <th scope="col" class="multi-line-header">Produktionsdatum</th>
          <th scope="col" class="multi-line-header">Operator</th>
          <th scope="col" class="multi-line-header">Chargen Nr.</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(entry, tableId) in entriesType2" :key="tableId">
          <td></td>
          <td>{{ entry.dateinproduction.replace("T", " ") }}</td>
          <td>{{ entry.firstname }} {{ entry.lastname }}</td>
          <td>{{ entry.cellbatch }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted } from "vue";
import { instance as axios } from "@/services/axios";

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
});

const entriesType1 = ref([]);
const entriesType2 = ref([]);

const fetchData = async (url) => {
  try {
    const { data } = await axios.get(url);

    // Separate the entries
    entriesType1.value = data.filter((entry) => entry.celltype === "22.4%-1 D");
    entriesType2.value = data.filter((entry) => entry.celltype === "22.4%-2 D");
  } catch (error) {
    console.log(error.message);
  }
};

onMounted(() => {
  fetchData(props.url);
});
</script>

<style scoped>
@media (max-width: 768px) {
  th {
    white-space: normal;
    word-wrap: break-word;
  }
}
</style>
